import { insert } from 'helpers';
import { storeRedux } from 'index';
import { isArray, cloneDeep } from 'lodash';
import actions from 'redux/actions';

const { saveLayoutMonitoring } = actions;

export const enumColumn = {
  title: 'title',
  contactGroup: 'contactGroup',

  // Grouped
  routes: 'routes',
  nameInRoute: 'nameInRoute',
  didGroupOrANI: 'didGroupOrANI',

  messageType: 'messageType',
  progress: 'progress',
  timeRemaining: 'timeRemaining',
  speed: 'speed',
  didInUsed: 'didInUsed',

  // Grouped
  statistic: 'statistic',
  total: 'total',
  campaignOffset: 'campaignOffset',
  sent: 'sent',
  delivered: 'delivered',
  clicked: 'clicked',
  replied: 'replied',
  failed: 'failed',
  optout: 'optout',
  blocked: 'blocked',
  attemptFailed: 'attemptFailed',
  convertor: 'convertor',

  mnoStatistic: 'mnoStatistic',

  // Grouped
  cost: 'cost',
  totalCost: 'totalCost',
  perClick: 'perClick',
  perMessage: 'perMessage',

  revenue: 'revenueCell',
  actions: 'actions',
  revenuePerMil: 'revenuePerMilCell',

  remainContact: 'remainContact',
  totalDid: 'totalDid',

  profit: 'profit',
  callbackCount: 'callbackCount',
  listenCounter: 'listenCounter',
  callDuration: 'callDuration',
  callDurationInMinute: 'callDurationInMinute',
  callDurationInSecond: 'callDurationInSecond',

  ROI: 'roi',
  revenuePerMilMinute: 'revenuePerMilMinute',
  revenuePerMilMessage: 'revenuePerMilMessage',
  revenuePerCalls: 'revenuePerCalls',
  callRate: 'callRate',

  activeCallCount: 'activeCallCount',

  ivrClickRate: 'ivrClickRate',
  ivrOptoutRate: 'ivrOptoutRate',
  username: 'username',
  amdCost: 'amdCost',
  amd: 'amd',
};

export const enumColumnsV2 = {
  ani: 'ani',
  expandable: 'expandable',
  title: 'title',
  route: 'route',
  didGroup: 'didGroup',
  contactGroup: 'contactGroup',
  remainContact: 'remainContact',
  totalDid: 'totalDid',
  statuses: 'statuses',
  timeRemaining: 'timeRemaining',
  speed: 'speed',
  campaignTotal: 'campaignTotal',
  campaignOffset: 'campaignOffset',
  sent: 'sent',
  delivered: 'delivered',
  clicked: 'clicked',
  replied: 'replied',
  callback: 'callback',
  callblocks: 'callblocks',
  acd: 'acd',
  listen: 'listen',
  convertor: 'convertor',
  failed: 'failed',
  optout: 'optout',
  blocked: 'blocked',
  attemptFailed: 'attemptFailed',
  ivrClickRate: 'ivrClickRate',
  optoutRate: 'optoutRate',
  amd: 'amd',
  campaignRejected: 'campaignRejected',
  totalCost: 'totalCost',
  costPerClick: 'costPerClick',
  costPerMessage: 'costPerMessage',
  amdCost: 'amdCost',
  revenue: 'revenue',
  revenuePerMil: 'revenuePerMil',
  profit: 'profit',
  roi: 'roi',
  revenuePerMilMinute: 'revenuePerMilMinute',
  revenuePerMilMessage: 'revenuePerMilMessage',
  revenuePerCalls: 'revenuePerCalls',
  callRate: 'callRate',
  ivrOptoutRate: 'ivrOptoutRate',
  rejected: 'rejected',
  total: 'total',
  actions: 'actions',
  ivrClickRateInbound: 'ivrClickRateInbound',
  ivrOptoutRateInbound: 'ivrOptoutRateInbound',
};

const enumColumnsMonitoring = 'columns-monitoring';
const enumVersionMonitoring = 'version-monitoring';
const VERSION_MONITORING = '0.0.3';

const templateColumns = [
  {
    column: 'Title',
    value: enumColumn.title,
    isChecked: true,
    isSortable: true,
    width: '300px',
  },
  {
    column: 'Contact group',
    value: enumColumn.contactGroup,
    isChecked: true,
    width: '150px',
  },
  {
    column: 'Routes',
    value: enumColumn.routes,
    isChecked: true,
    width: '300px',
    subColumn: [
      {
        column: 'Name',
        value: enumColumn.nameInRoute,
        isChecked: true,
        isChild: true,
        width: '150px',
      },
      {
        column: 'DID group / ANI',
        value: enumColumn.didGroupOrANI,
        isChecked: true,
        isChild: true,
        width: '150px',
      },
    ],
  },
  {
    column: 'Total DID',
    value: enumColumn.totalDid,
    isChecked: true,
    isSortable: true,
    width: '100px',
  },
  {
    column: 'Remain contact',
    value: enumColumn.remainContact,
    isChecked: true,
    isSortable: true,
    width: '130px',
  },
  {
    column: 'Message type',
    value: enumColumn.messageType,
    isChecked: true,
    isSortable: true,
    width: '130px',
  },
  {
    column: 'Progress',
    value: enumColumn.progress,
    isChecked: true,
    isSortable: true,
    width: '200px',
  },
  {
    column: 'Time remaining',
    value: enumColumn.timeRemaining,
    isChecked: true,
    width: '150px',
  },
  {
    column: 'Speed',
    value: enumColumn.speed,
    isChecked: true,
    width: '150px',
  },
  {
    column: 'Statistic',
    value: enumColumn.statistic,
    isChecked: true,
    width: '675px',
    subColumn: [
      {
        column: 'Total',
        value: enumColumn.total,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Campaign Offset',
        value: enumColumn.campaignOffset,
        isChecked: true,
        isChild: true,
        width: '140px',
      },
      {
        column: 'Sent',
        value: enumColumn.sent,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Delivered',
        value: enumColumn.delivered,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Clicked',
        value: enumColumn.clicked,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Replied',
        value: enumColumn.replied,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Callback',
        value: enumColumn.callbackCount,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Call Duration (minute)',
        value: enumColumn.callDurationInMinute,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '150px',
      },
      {
        column: 'Average Call Duration (second)',
        value: enumColumn.callDurationInSecond,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '150px',
      },
      {
        column: 'Listen',
        value: enumColumn.listenCounter,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Convertor',
        value: enumColumn.convertor,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Failed',
        value: enumColumn.failed,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Optout',
        value: enumColumn.optout,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Blocked',
        value: enumColumn.blocked,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Attempt failed',
        value: enumColumn.attemptFailed,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '120px',
      },
      {
        column: 'IVR Clicked rate',
        value: enumColumn.ivrClickRate,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '120px',
      },
      {
        column: 'IVR Optout rate',
        value: enumColumn.ivrOptoutRate,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '120px',
      },
      {
        column: 'AMD',
        value: enumColumn.amd,
        isChecked: true,
        isChild: true,
        isSortable: false,
        width: '100px',
      },
    ],
  },
  {
    column: 'Cost',
    value: enumColumn.cost,
    isChecked: true,
    width: '300px',
    subColumn: [
      {
        column: 'Total cost',
        value: enumColumn.totalCost,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Per clicked',
        value: enumColumn.perClick,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'Per message',
        value: enumColumn.perMessage,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
      {
        column: 'AMD Cost',
        value: enumColumn.amdCost,
        isChecked: true,
        isChild: true,
        isSortable: true,
        width: '100px',
      },
    ],
  },
  {
    column: 'Revenue',
    value: enumColumn.revenue,
    isChecked: true,
    isSortable: true,
    width: '100px',
  },
  {
    column: 'Rev/mil',
    value: enumColumn.revenuePerMil,
    isChecked: true,
    isSortable: true,
    width: '140px',
  },

  {
    column: 'Profit',
    value: enumColumn.profit,
    isChecked: true,
    isSortable: true,
    width: '140px',
  },
  // {
  //   column: 'Actions',
  //   value: enumColumn.actions,
  //   isChecked: true,
  // },
  {
    column: 'Active calls',
    value: enumColumn.activeCallCount,
    isChecked: true,
    isSortable: true,
    width: '140px',
  },
  {
    column: 'Username',
    value: enumColumn.username,
    isChecked: true,
    isSortable: false,
    width: '140px',
  },
];
class ColumnMonitoringModel {
  constructor() {
    // ColumnMonitoringModel.checkVersionMonitoring();
    // const columnsLocalStorage = ColumnMonitoringModel.getColumnsFromLocalStorage();

    this.columns = templateColumns;
  }

  /**
   *
   * @param {string} width
   */
  static getWidthOfCol(width) {
    if (!width) {
      return undefined;
    }

    return Number(width?.split('px')?.[0]);
  }

  //! DEPRECATED!
  static putColumnsToLocalStorage(columns = []) {
    localStorage.setItem(enumColumnsMonitoring, JSON.stringify(columns));
  }

  //! DEPRECATED!
  static getColumnsFromLocalStorage() {
    if (localStorage.getItem(enumColumnsMonitoring)) {
      return JSON.parse(localStorage.getItem(enumColumnsMonitoring));
    }

    return null;
  }

  //! DEPRECATED!
  static checkVersionMonitoring() {
    const version = localStorage.getItem(enumVersionMonitoring);

    if (version !== VERSION_MONITORING) {
      switch (VERSION_MONITORING) {
        case '0.0.1':
          ColumnMonitoringModel.putColumnsToLocalStorage(templateColumns);
          break;

        //* Add convertor column
        case '0.0.2': {
          const columnsLocalStorage = ColumnMonitoringModel.getColumnsFromLocalStorage();
          if (columnsLocalStorage) {
            const nextCol = cloneDeep(columnsLocalStorage);
            const statisticCol = nextCol.find((el) => el.value === enumColumn.statistic);
            if (statisticCol) {
              statisticCol.subColumn = insert(statisticCol.subColumn, 4, {
                column: 'Convertor',
                value: enumColumn.convertor,
                isChecked: true,
                isChild: true,
                isSortable: true,
                width: '100px',
              });
            }

            ColumnMonitoringModel.putColumnsToLocalStorage(nextCol);
          }
          break;
        }

        //* Add total DID, Remain contact
        case '0.0.3': {
          const columnsLocalStorage = ColumnMonitoringModel.getColumnsFromLocalStorage();
          if (columnsLocalStorage) {
            let nextCol = cloneDeep(columnsLocalStorage);
            nextCol = insert(
              nextCol,
              4,
              {
                column: 'Total DID',
                value: enumColumn.totalDid,
                isChecked: true,
                isSortable: true,
                width: '100px',
              },
              {
                column: 'Remain contact',
                value: enumColumn.remainContact,
                isChecked: true,
                isSortable: true,
                width: '100px',
              },
            );

            ColumnMonitoringModel.putColumnsToLocalStorage(nextCol);
          }
          break;
        }

        default:
          break;
      }

      localStorage.setItem(enumVersionMonitoring, VERSION_MONITORING);
      return true;
    }

    return false;
  }

  static flatColumns() {
    let tempArr = [];
    const recursive = (columns = []) => {
      for (let col of columns) {
        tempArr = [...tempArr, col];

        if (isArray(col?.subColumn)) {
          //* To know which parent of subColumn
          const subColumnWithParent = col?.subColumn.map((el) => ({ ...el, parent: col.value }));
          recursive(subColumnWithParent);
        }
      }

      return tempArr;
    };

    return recursive;
  }

  static defineFirstColumnToFreeze(flatColumns) {
    let tempArr = cloneDeep(flatColumns);

    //* To define which element is first column to sticky
    let prevParent = '';
    for (let i = 0; i < tempArr.length; i++) {
      const { parent } = tempArr[i];

      //* In case the first column has sub column -> all columns in subColumns has isFirstColumn property
      if (parent) {
        //* Make all sub column of one parent has isFirstColumn property
        //* Cached prevParent
        if (!prevParent) {
          prevParent = parent;
        }

        //* If next column has different parent -> break
        if (prevParent !== parent) {
          break;
        }

        tempArr[i].isFirstColumn = true;
      } else {
        //* If not -> take first column to sticky
        if (i === 0) {
          tempArr[i].isFirstColumn = true;
        }
        break;
      }
    }

    return tempArr;
  }

  static async saveLayout(body) {
    try {
      storeRedux.dispatch(saveLayoutMonitoring({ nextColumns: body }));
    } catch (error) {
      alert(JSON.stringify(error));
    }
  }

  static hideColumnTableMonitoring(columns, fieldWannaHideColumns = []) {
    if (isArray(columns) && isArray(fieldWannaHideColumns)) {
      const nextColumns = cloneDeep(columns);
      nextColumns.forEach((col) => {
        if (isArray(col?.subColumn)) {
          col.subColumn = col?.subColumn.filter((el) => !fieldWannaHideColumns.includes(el.value));
        }

        if (isArray(col?.subCol)) {
          col.subCol = col?.subCol.filter((el) => !fieldWannaHideColumns.includes(el.value));
        }
      });

      return nextColumns.filter((el) => !fieldWannaHideColumns.includes(el.value));
    }

    return [];
  }
}

export default ColumnMonitoringModel;
